@let quote = smartquote();

<sf-page-title title="Smart Quote" icon="file-invoice-dollar" docUrl="https://surefire-software.gitbook.io/docs/">
    @if (!quote) {
        <p>Create a new Smart Quote, enter the job details, any required parts and labour costs.</p>
    }
    @if (quote) {
        <div class="d-flex gap-1 mb-2">
            <span
                class="badge"
                [class.text-bg-dark]="!quote.accepted && !quote.declined"
                [class.text-bg-danger]="quote.declined"
                [class.text-bg-success]="quote.accepted"
                [ngbTooltip]="
                    quote.accepted
                        ? 'The customer has accepted this quote'
                        : quote.declined
                          ? 'The customer has declined this quote'
                          : 'Awaiting customer response'
                "
                >{{ quote.accepted ? 'Quote Accepted' : quote.declined ? 'Quote Declined' : 'Awaiting Customer' }}</span
            >

            <span
                class="badge"
                [class.text-bg-danger]="!quote.hasOrderBeenPlaced"
                [class.text-bg-success]="quote.hasOrderBeenPlaced"
                [ngbTooltip]="
                    quote.hasOrderBeenPlaced
                        ? 'Parts have been ordered for this quote'
                        : 'Parts have not been ordered yet'
                "
                >{{ quote.hasOrderBeenPlaced ? 'Parts Ordered' : 'Awaiting Order' }}</span
            >

            <span
                class="badge"
                [class.text-bg-danger]="!quote.appointmentId"
                [class.text-bg-success]="quote.appointmentId"
                [ngbTooltip]="
                    quote.appointmentId ? 'An appointment has been booked for this quote' : 'No appointment booked yet'
                "
                >{{ quote.appointmentId ? 'Appointment Booked' : 'No Appointment Booked' }}</span
            >
            <span
                class="badge"
                [class.text-bg-danger]="!quote.sentEmailToCustomer"
                [class.text-bg-success]="quote.sentEmailToCustomer"
                [ngbTooltip]="quote.sentEmailToCustomer ? 'Quote sent to customer' : 'Quote not sent to customer'"
                >{{ quote.sentEmailToCustomer ? 'Quote Sent' : 'Quote Not Sent' }}</span
            >
        </div>
        <div class="d-flex flex-column flex-md-row small justify-content-between align-items-md-center">
            <p class="mb-2">
                Created by <b>{{ quote.createdBy.fullName }}</b> on {{ quote.created | date: 'EEEE dd MMMM yyyy' }} at
                {{ quote.created | date: 'HH:mma' }}.
            </p>
        </div>
    }

    @if (smartquote(); as smartquote) {
        <div class="quote-actions" role="toolbar" aria-label="Quote actions">
            <button
                sfButton
                size="sm"
                color="info"
                icon="file-pdf"
                tooltip="View the PDF version of this quote"
                tooltipContainer="body"
                (click)="openPDFModal()">
                View PDF
            </button>
            <button
                sfButton
                size="sm"
                color="secondary"
                tooltip="Email this quote to the customer"
                tooltipContainer="body"
                icon="external-link"
                (click)="openEmailModal()">
                Email Quote
            </button>
            <a
                [hidden]="smartquote.appointmentId"
                sfButton
                size="sm"
                color="secondary"
                routerLink="/diary/calendar"
                tooltip="Create an appointment associated with this quote"
                tooltipContainer="body"
                [queryParams]="{
                    smartQuoteId: smartquote.id,
                    smartQuoteTotal: totalExVatCost()?.toFixed(2),
                    smartQuoteDeposit: deposit()?.toFixed(2),
                    customerId: smartquote.customerId,
                }"
                icon="calendar"
                >Create Appointment</a
            >
            <button sfButton size="sm" color="secondary" icon="external-link" (click)="openSendOrderModal()">
                Send Order
            </button>
            <ng-template [ngxPermissionsOnly]="'Wolseley'">
                <button
                    sfButton
                    size="sm"
                    color="secondary"
                    icon="external-link"
                    tooltip="Check stock at Wolseley"
                    tooltipContainer="body"
                    [disabled]="!canOrderFromWolseley()"
                    (click)="openWolseleyStockCheck()">
                    Check Stock
                </button>
                <a
                    sfButton
                    size="sm"
                    color="secondary"
                    routerLink="/wolseley-order"
                    tooltip="Place an order with Wolseley"
                    tooltipContainer="body"
                    [disabled]="!canOrderFromWolseley()"
                    [queryParams]="{
                        smartQuoteId: smartquote.id,
                    }"
                    icon="external-link"
                    >Place Order</a
                >
            </ng-template>
            <a
                sfButton
                size="sm"
                color="success"
                routerLink="/diary/calendar"
                tooltip="Create an appointment associated with this quote"
                tooltipContainer="body"
                [disabled]="smartquote.accepted"
                [queryParams]="{
                    smartQuoteId: smartquote.id,
                    smartQuoteTotal: totalExVatCost()?.toFixed(2),
                    smartQuoteDeposit: deposit()?.toFixed(2),
                    customerId: smartquote.customerId,
                }"
                icon="calendar"
                >{{ smartquote.accepted ? 'Accepted' : 'Schedule & Accept' }}</a
            >
            <button
                sfButton
                size="sm"
                color="warning"
                tooltip="Decline this quote on behalf of the customer"
                tooltipContainer="body"
                icon="xmark-circle"
                [disabled]="smartquote.declined"
                (click)="smartquoteHelperService.markQuoteAsDeclined()">
                Decline
            </button>
            <button
                sfButton
                size="sm"
                color="primary"
                tooltip="Copy this quote to a new quote (you will be automatically redirected to the new quote)"
                tooltipContainer="body"
                icon="copy"
                (click)="smartquoteHelperService.copySmartquote()">
                Copy
            </button>
            <button
                sfButton
                size="sm"
                color="danger"
                tooltip="Delete this quote"
                tooltipContainer="body"
                icon="trash"
                (click)="smartquoteHelperService.deleteSmartQuote()">
                Delete
            </button>
            <a
                sfButton
                size="sm"
                color="success"
                href="{{ smartquote.acceptanceUrl }}"
                target="_blank"
                tooltip="View Landing Page"
                tooltipContainer="body"
                icon="external-link"
                >Landing Page</a
            >
        </div>
        @if (smartquote?.accepted || smartquote?.declined) {
            <ngb-alert [type]="quote!.accepted ? 'success' : 'danger'" [dismissible]="false" class="mt-2 mb-0"
                ><p class="text-center mb-0 fw-bold">{{ smartQuoteStatus() }}</p></ngb-alert
            >
        }
    }
</sf-page-title>
<div class="pb-2"></div>
